module.exports = __webpack_public_path__ + "static/media/whitelogo.ebe4bcef.png";